import { BrandChipContainer } from "./BrandChipContainer";
import { BrandChipItem } from "./BrandsQuerybar.styled";

export interface IBrandChip {
    unselectedBrands: string[];
    onUpdateBrand: (currentBrand: string, brand: string) => void;
    onRemoveBrand: (brand: string) => void;
    selectedBrand: string;
}

export const BrandChip = ({ unselectedBrands, onUpdateBrand, onRemoveBrand, selectedBrand }: IBrandChip) => {
    return (
        <BrandChipContainer
            unselectedBrands={unselectedBrands}
            onItemClick={(brand) => onUpdateBrand(selectedBrand, brand)}
        >
            <div>
                <BrandChipItem
                    text={selectedBrand}
                    image=""
                    isCompare={true}
                    onItemClick={undefined}
                    onButtonClick={() => onRemoveBrand(selectedBrand)}
                    renderImageComponent={() => <div style={{ padding: "4px" }} />}
                />
            </div>
        </BrandChipContainer>
    );
};
